import { render, staticRenderFns } from "./WipSummary.vue?vue&type=template&id=19be0b54&"
import script from "./WipSummary.vue?vue&type=script&lang=js&"
export * from "./WipSummary.vue?vue&type=script&lang=js&"
import style0 from "./WipSummary.vue?vue&type=style&index=0&id=19be0b54&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports